module.exports = __webpack_public_path__ + "static/Firewatch5-b6aab81bf5a4190d2cf2f754900db170.webp";